import { Header, Item, TabMenu } from '@ordr-as/umami-react'
import { NavLink, useLocation } from 'react-router-dom'

const AppHeader = () => {
    const location = useLocation()
    const selectedTab = location.pathname.split('/')[1]

    return (
        <Header headerClass="flex justify-start gap-4">
            <div className="flex justify-around w-full">
                <TabMenu selectedKeys={[selectedTab]}>
                    <Item key={'payments'} textValue="payments">
                        <NavLink to={'/payments'}>Payments</NavLink>
                    </Item>
                    <Item key={'terminals'} textValue="terminals">
                        <NavLink to={'/terminals'}>Terminals</NavLink>
                    </Item>
                    <Item key={'payment-methods'} textValue="payment-methods">
                        <NavLink to={'/payment-methods'}>Payment methods</NavLink>
                    </Item>
                    <Item key={'payment-fees'} textValue="payment-fees">
                        <NavLink to={'/payment-fees'}>Payment fees</NavLink>
                    </Item>
                    <Item key={'payment-operations'} textValue="payment-operations">
                        <NavLink to={'/payment-operations/psp-notifications'}>Payment operations</NavLink>
                    </Item>
                </TabMenu>
            </div>
        </Header>
    )
}

export default AppHeader
